;(function () {
  'use strict';

  const legacyPaths = {
    '/collections/frigg-daisy': '/collections/daisy-pacifiers',
    '/collections/frigg-fairytale': '/collections/fairytale-pacifiers',
    '/collections/frigg-viking': '/collections/little-viking-pacifiers',
    '/collections/rope': '/collections/rope-pacifiers',
    '/collections/frigg-moon-phase': '/collections/moon-phase-pacifiers',
    '/collections/frigg-lucky': '/collections/lucky-pacifiers',
    '/collections/frigg-butterfly': '/collections/butterfly-pacifiers',
    '/collections/frigg-night': '/collections/night-pacifiers',
    '/collections/frigg-4-packs': '/collections/frigg-4-pack',
    '/collections/frigg-6-packs': '/collections/frigg-6-pack',
    '/collections/pacifiers': '/collections/all-pacifiers',
    '/collections/personalised-pacifiers': '/collections/all-pacifiers',
    '/pacifiers/fairytale-pacifiers/': '/collections/fairytale-pacifiers',
    '/pages/frigg-little-viking-pacifiers':
      '/collections/little-viking-pacifiers',
    '/products/frigg-babys-first-pacifier-4-pack-floral-heart-blush':
      '/products/frigg-babys-first-pacifier-4-pack-floral-heart',
    '/products/frigg-babys-first-pacifier-4-pack-moonlight-sailing-sage':
      '/products/frigg-babys-first-pacifier-4-pack-moonlight-sailing',
    '/products/frigg-round-pacifier-daisy-latex-size-1-cotton-candy':
      '/products/frigg-round-pacifier-daisy',
    '/products/frigg-anatomical-pacifier-butterfly-silicone-size-1-cream':
      '/products/frigg-anatomical-pacifier-butterfly',
    '/products/frigg-round-pacifier-fairytale-x-hc-andersen-latex-size-1-ole-lukoie':
      '/products/frigg-round-pacifier-fairytale-x-h-c-andersen',
    '/products/frigg-round-pacifier-little-viking-latex-size-1-bjorn':
      '/products/frigg-round-pacifier-little-viking',
    '/products/frigg-symmetrical-pacifier-lucky-silicone-size-1-cream':
      '/products/frigg-symmetrical-pacifier-lucky',
    '/products/frigg-round-pacifier-moon-phase-latex-size-1-cream':
      '/products/frigg-round-pacifier-moon-phase',
    '/products/frigg-round-pacifier-daisy-night-latex-size-1-blush':
      '/products/frigg-round-pacifier-daisy-night',
    '/products/frigg-round-pacifier-moon-phase-night-latex-size-1-blush':
      '/products/frigg-round-pacifier-moon-phase-night',
    '/products/frigg-round-pacifier-rope-night-latex-size-1-blush':
      '/products/frigg-round-pacifier-rope-night',
    '/products/frigg-round-pacifier-rope-latex-size-1-cocoa':
      '/products/frigg-round-pacifier-rope',
  };

  function repairLink(link) {
    const rawHref = link.getAttribute('href');
    if (!rawHref) return;

    if (
      /^www\.instagram\.com\/friggofficial\.me\/?$/i.test(rawHref) ||
      rawHref.includes('/www.instagram.com/friggofficial.me')
    ) {
      link.href = 'https://www.instagram.com/friggofficial.me';
      return;
    }

    let url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    const replacement = legacyPaths[url.pathname];
    if (replacement) {
      link.href = replacement;
    }
  }

  function repairLinks(root) {
    root.querySelectorAll('a[href]').forEach(repairLink);
  }

  function init() {
    repairLinks(document);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('a[href]')) repairLink(node);
          repairLinks(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})()
